import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/** Centered spinner with an explicit message — users always know what is happening. */
@Component({
  selector: 'ds-loading-state',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="loading" role="status">
      <span class="loading__spinner" aria-hidden="true"></span>
      <p class="loading__message">{{ message() }}</p>
    </div>
  `,
  styles: `
    .loading {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: var(--space-4);
      padding: var(--space-7) var(--space-5);
      text-align: center;
    }

    .loading__spinner {
      width: 48px;
      height: 48px;
      border: 5px solid var(--color-teal-100);
      border-top-color: var(--color-primary);
      border-radius: 50%;
      animation: loading-spin 0.9s linear infinite;
    }

    .loading__message {
      margin: 0;
      font-size: var(--text-md);
      color: var(--color-text-secondary);
    }

    @keyframes loading-spin {
      to {
        transform: rotate(360deg);
      }
    }

    @media (prefers-reduced-motion: reduce) {
      .loading__spinner {
        animation: none;
        border-top-color: var(--color-teal-100);
        border-bottom-color: var(--color-primary);
      }
    }
  `,
})
export class LoadingStateComponent {
  message = input('Sedang memuat…');
}
